export default __webpack_public_path__ + "static/media/IconDesc_SolidBiofuel.256.7e74c1b8.png";